import { useAuth0 } from "@auth0/auth0-react";
import Button from "../common/Button";

interface RegisterButtonProps {
  className?: string;
}

const RegisterButton = ({ className }: RegisterButtonProps) => {
  const { isAuthenticated } = useAuth0();
  
  if (isAuthenticated) {
    return null;
  }

  const handleClick = () => {
    window.open('https://forms.gle/6V13z9SJ33ifFwih8', '_blank', 'noopener,noreferrer');
  };

  return (
    <Button 
      className={className}
      onClick={handleClick}
    >
      Registrarme como Proveedor
    </Button>
  );
};

export default RegisterButton;